import { FC } from 'react';
import { Image, Space, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface Props {
  title: string;
  description: string;
  image: string;
  altText: string;
  imageSize: number;
  imgNumber: number;
}

const SlideItemSmall: FC<Props> = ({
  title,
  image,
  description,
  imageSize,
  altText,
  imgNumber,
}: Props): JSX.Element => {
  const [t] = useTranslation('carousel');

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
        <Title order={1} lineClamp={3} style={{ fontSize: '1.5rem', textAlign: 'left' }}>
          {t(title)}
        </Title>
        <Space h="sm" />
        <p style={{ textAlign: 'left', margin: 0, padding: 0 }}>{t(description)}</p>
      </div>
      <div>
        <Image maw={imageSize} mx="auto" radius="md" src={image} alt={`${t(altText, { number: imgNumber })}`} />
      </div>
    </div>
  );
};

export default SlideItemSmall;
